// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddExpenseToInvoiceData, AddExpenseToInvoiceErrors, AddExpenseToInvoiceResponses, AddTicketMessageData, AddTicketMessageErrors, AddTicketMessageResponses, AddTimeEntryToInvoiceData, AddTimeEntryToInvoiceErrors, AddTimeEntryToInvoiceResponses, CancelAccountDeletionData, CancelAccountDeletionErrors, CancelAccountDeletionResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmEmailData, ConfirmEmailErrors, ConfirmEmailResponses, ConfirmMfaEnrollmentData, ConfirmMfaEnrollmentErrors, ConfirmMfaEnrollmentResponses, ConvertQuoteToInvoiceData, ConvertQuoteToInvoiceErrors, ConvertQuoteToInvoiceResponses, CreateAssetDepreciationEntryData, CreateAssetDepreciationEntryErrors, CreateAssetDepreciationEntryResponses, CreateClientData, CreateClientErrors, CreateClientResponses, CreateExpenseCategoryData, CreateExpenseCategoryErrors, CreateExpenseCategoryResponses, CreateExpenseData, CreateExpenseErrors, CreateExpenseResponses, CreateFixedAssetData, CreateFixedAssetErrors, CreateFixedAssetResponses, CreateInvoiceData, CreateInvoiceErrors, CreateInvoiceItemData, CreateInvoiceItemErrors, CreateInvoiceItemResponses, CreateInvoiceReminderData, CreateInvoiceReminderErrors, CreateInvoiceReminderResponses, CreateInvoiceResponses, CreateMileageEntryData, CreateMileageEntryErrors, CreateMileageEntryResponses, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreateProjectStatusData, CreateProjectStatusErrors, CreateProjectStatusResponses, CreateQuoteData, CreateQuoteErrors, CreateQuoteResponses, CreateRecurringInvoiceData, CreateRecurringInvoiceErrors, CreateRecurringInvoiceResponses, CreateRecurringTaskRuleData, CreateRecurringTaskRuleErrors, CreateRecurringTaskRuleResponses, CreateReportViewData, CreateReportViewErrors, CreateReportViewResponses, CreateTaskData, CreateTaskErrors, CreateTaskResponses, CreateTaxSetAsideEntryData, CreateTaxSetAsideEntryErrors, CreateTaxSetAsideEntryResponses, CreateTicketData, CreateTicketErrors, CreateTicketResponses, CreateTimeEntryData, CreateTimeEntryErrors, CreateTimeEntryResponses, CreateTimeEntryTagData, CreateTimeEntryTagErrors, CreateTimeEntryTagResponses, CreateUserRateData, CreateUserRateErrors, CreateUserRateResponses, CreateWorkspaceData, CreateWorkspaceErrors, CreateWorkspaceResponses, DeleteAssetDepreciationEntryData, DeleteAssetDepreciationEntryErrors, DeleteAssetDepreciationEntryResponses, DeleteClientData, DeleteClientErrors, DeleteClientResponses, DeleteExpenseCategoryData, DeleteExpenseCategoryErrors, DeleteExpenseCategoryResponses, DeleteExpenseData, DeleteExpenseErrors, DeleteExpenseResponses, DeleteFixedAssetData, DeleteFixedAssetErrors, DeleteFixedAssetResponses, DeleteInvoiceData, DeleteInvoiceErrors, DeleteInvoiceItemData, DeleteInvoiceItemErrors, DeleteInvoiceItemResponses, DeleteInvoiceReminderData, DeleteInvoiceReminderErrors, DeleteInvoiceReminderResponses, DeleteInvoiceResponses, DeleteMileageEntryData, DeleteMileageEntryErrors, DeleteMileageEntryResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeleteProjectStatusData, DeleteProjectStatusErrors, DeleteProjectStatusResponses, DeleteQuoteData, DeleteQuoteErrors, DeleteQuoteResponses, DeleteRecurringInvoiceData, DeleteRecurringInvoiceErrors, DeleteRecurringInvoiceResponses, DeleteRecurringTaskRuleData, DeleteRecurringTaskRuleErrors, DeleteRecurringTaskRuleResponses, DeleteReportViewData, DeleteReportViewErrors, DeleteReportViewResponses, DeleteTaskData, DeleteTaskErrors, DeleteTaskResponses, DeleteTaxSetAsideEntryData, DeleteTaxSetAsideEntryErrors, DeleteTaxSetAsideEntryResponses, DeleteTimeEntryData, DeleteTimeEntryErrors, DeleteTimeEntryResponses, DeleteTimeEntryTagData, DeleteTimeEntryTagErrors, DeleteTimeEntryTagResponses, DeleteUploadData, DeleteUploadErrors, DeleteUploadResponses, DeleteUserRateData, DeleteUserRateErrors, DeleteUserRateResponses, DeleteWorkspaceData, DeleteWorkspaceErrors, DeleteWorkspaceMemberData, DeleteWorkspaceMemberErrors, DeleteWorkspaceMemberResponses, DeleteWorkspaceResponses, DisableMfaData, DisableMfaErrors, DisableMfaResponses, EnrollMfaData, EnrollMfaErrors, EnrollMfaResponses, EvaluateBudgetAlertsData, EvaluateBudgetAlertsErrors, EvaluateBudgetAlertsResponses, ExportAccountData, ExportAccountErrors, ExportAccountResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAccountDeletionData, GetAccountDeletionErrors, GetAccountDeletionResponses, GetAssetDepreciationEntryData, GetAssetDepreciationEntryErrors, GetAssetDepreciationEntryResponses, GetClientData, GetClientErrors, GetClientResponses, GetExpenseCategoryData, GetExpenseCategoryErrors, GetExpenseCategoryResponses, GetExpenseData, GetExpenseErrors, GetExpenseResponses, GetFixedAssetData, GetFixedAssetErrors, GetFixedAssetResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetInvoiceAmendmentData, GetInvoiceAmendmentErrors, GetInvoiceAmendmentResponses, GetInvoiceData, GetInvoiceErrors, GetInvoiceItemData, GetInvoiceItemErrors, GetInvoiceItemResponses, GetInvoicePaymentData, GetInvoicePaymentErrors, GetInvoicePaymentResponses, GetInvoiceRefundData, GetInvoiceRefundErrors, GetInvoiceRefundResponses, GetInvoiceReminderData, GetInvoiceReminderErrors, GetInvoiceReminderResponses, GetInvoiceResponses, GetMeData, GetMeErrors, GetMeResponses, GetMileageEntryData, GetMileageEntryErrors, GetMileageEntryResponses, GetProjectData, GetProjectErrors, GetProjectResponses, GetProjectStatusData, GetProjectStatusErrors, GetProjectStatusResponses, GetPublicInvoiceData, GetPublicInvoiceErrors, GetPublicInvoiceResponses, GetPublicQuoteData, GetPublicQuoteErrors, GetPublicQuoteResponses, GetQuoteData, GetQuoteErrors, GetQuoteItemData, GetQuoteItemErrors, GetQuoteItemResponses, GetQuoteResponses, GetRecurringInvoiceData, GetRecurringInvoiceErrors, GetRecurringInvoiceResponses, GetRecurringTaskRuleData, GetRecurringTaskRuleErrors, GetRecurringTaskRuleResponses, GetReportViewData, GetReportViewErrors, GetReportViewResponses, GetTaskData, GetTaskErrors, GetTaskResponses, GetTaxSetAsideEntryData, GetTaxSetAsideEntryErrors, GetTaxSetAsideEntryResponses, GetTicketData, GetTicketErrors, GetTicketResponses, GetTimeEntryData, GetTimeEntryErrors, GetTimeEntryResponses, GetTimeEntryTagData, GetTimeEntryTagErrors, GetTimeEntryTagResponses, GetUploadUrlData, GetUploadUrlErrors, GetUploadUrlResponses, GetUserRateData, GetUserRateErrors, GetUserRateResponses, GetWorkspaceData, GetWorkspaceErrors, GetWorkspaceInvitationData, GetWorkspaceInvitationErrors, GetWorkspaceInvitationResponses, GetWorkspaceMemberData, GetWorkspaceMemberErrors, GetWorkspaceMemberResponses, GetWorkspaceResponses, InviteToWorkspaceData, InviteToWorkspaceErrors, InviteToWorkspaceResponses, IssueInvoiceLinkData, IssueInvoiceLinkErrors, IssueInvoiceLinkResponses, IssueQuoteLinkData, IssueQuoteLinkErrors, IssueQuoteLinkResponses, ListAssetDepreciationEntrysData, ListAssetDepreciationEntrysErrors, ListAssetDepreciationEntrysResponses, ListClientsData, ListClientsErrors, ListClientsResponses, ListExpenseCategorysData, ListExpenseCategorysErrors, ListExpenseCategorysResponses, ListExpensesData, ListExpensesErrors, ListExpensesResponses, ListFixedAssetsData, ListFixedAssetsErrors, ListFixedAssetsResponses, ListInvoiceAmendmentsData, ListInvoiceAmendmentsErrors, ListInvoiceAmendmentsResponses, ListInvoiceItemsData, ListInvoiceItemsErrors, ListInvoiceItemsResponses, ListInvoicePaymentsData, ListInvoicePaymentsErrors, ListInvoicePaymentsResponses, ListInvoiceRefundsData, ListInvoiceRefundsErrors, ListInvoiceRefundsResponses, ListInvoiceRemindersData, ListInvoiceRemindersErrors, ListInvoiceRemindersResponses, ListInvoicesData, ListInvoicesErrors, ListInvoicesResponses, ListMileageEntrysData, ListMileageEntrysErrors, ListMileageEntrysResponses, ListNotificationsData, ListNotificationsErrors, ListNotificationsResponses, ListProjectsData, ListProjectsErrors, ListProjectsResponses, ListProjectStatussData, ListProjectStatussErrors, ListProjectStatussResponses, ListQuoteItemsData, ListQuoteItemsErrors, ListQuoteItemsResponses, ListQuotesData, ListQuotesErrors, ListQuotesResponses, ListRecurringInvoicesData, ListRecurringInvoicesErrors, ListRecurringInvoicesResponses, ListRecurringTaskRulesData, ListRecurringTaskRulesErrors, ListRecurringTaskRulesResponses, ListReportViewsData, ListReportViewsErrors, ListReportViewsResponses, ListTasksData, ListTasksErrors, ListTasksResponses, ListTaxSetAsideEntrysData, ListTaxSetAsideEntrysErrors, ListTaxSetAsideEntrysResponses, ListTicketsData, ListTicketsErrors, ListTicketsResponses, ListTimeEntrysData, ListTimeEntrysErrors, ListTimeEntrysResponses, ListTimeEntryTagsData, ListTimeEntryTagsErrors, ListTimeEntryTagsResponses, ListUserRatesData, ListUserRatesErrors, ListUserRatesResponses, ListWorkspaceInvitationsData, ListWorkspaceInvitationsErrors, ListWorkspaceInvitationsResponses, ListWorkspaceMembersData, ListWorkspaceMembersErrors, ListWorkspaceMembersResponses, ListWorkspacesData, ListWorkspacesErrors, ListWorkspacesResponses, MarkNotificationReadData, MarkNotificationReadErrors, MarkNotificationReadResponses, RecordInvoicePaymentData, RecordInvoicePaymentErrors, RecordInvoicePaymentResponses, RecordInvoiceRefundData, RecordInvoiceRefundErrors, RecordInvoiceRefundResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegisterDevicePushTokenData, RegisterDevicePushTokenErrors, RegisterDevicePushTokenResponses, RequestAccountDeletionData, RequestAccountDeletionErrors, RequestAccountDeletionResponses, RequestMagicLinkData, RequestMagicLinkErrors, RequestMagicLinkResponses, ResendConfirmationData, ResendConfirmationErrors, ResendConfirmationResponses, ResendWorkspaceInvitationData, ResendWorkspaceInvitationErrors, ResendWorkspaceInvitationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RespondToPublicQuoteData, RespondToPublicQuoteErrors, RespondToPublicQuoteResponses, RespondToWorkspaceInvitationData, RespondToWorkspaceInvitationErrors, RespondToWorkspaceInvitationResponses, RevenueCatWebhookData, RevenueCatWebhookErrors, RevenueCatWebhookResponses, RevokeWorkspaceInvitationData, RevokeWorkspaceInvitationErrors, RevokeWorkspaceInvitationResponses, RunRecurringInvoicesData, RunRecurringInvoicesErrors, RunRecurringInvoicesResponses, RunRecurringTasksData, RunRecurringTasksErrors, RunRecurringTasksResponses, SendInvoiceEmailData, SendInvoiceEmailErrors, SendInvoiceEmailResponses, SendInvoiceRemindersData, SendInvoiceRemindersErrors, SendInvoiceRemindersResponses, SendQuoteEmailData, SendQuoteEmailErrors, SendQuoteEmailResponses, SendScheduledDocumentsData, SendScheduledDocumentsErrors, SendScheduledDocumentsResponses, SetTicketStatusData, SetTicketStatusErrors, SetTicketStatusResponses, SetTimeEntryTagsData, SetTimeEntryTagsErrors, SetTimeEntryTagsResponses, SignInData, SignInErrors, SignInResponses, SignOutData, SignOutErrors, SignOutResponses, SignUpData, SignUpErrors, SignUpResponses, SubmitContactData, SubmitContactErrors, SubmitContactResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, UpdateAssetDepreciationEntryData, UpdateAssetDepreciationEntryErrors, UpdateAssetDepreciationEntryResponses, UpdateClientData, UpdateClientErrors, UpdateClientResponses, UpdateExpenseCategoryData, UpdateExpenseCategoryErrors, UpdateExpenseCategoryResponses, UpdateExpenseData, UpdateExpenseErrors, UpdateExpenseResponses, UpdateFixedAssetData, UpdateFixedAssetErrors, UpdateFixedAssetResponses, UpdateInvoiceData, UpdateInvoiceDetailsData, UpdateInvoiceDetailsErrors, UpdateInvoiceDetailsResponses, UpdateInvoiceErrors, UpdateInvoiceItemData, UpdateInvoiceItemErrors, UpdateInvoiceItemResponses, UpdateInvoiceReminderData, UpdateInvoiceReminderErrors, UpdateInvoiceReminderResponses, UpdateInvoiceResponses, UpdateMeData, UpdateMeErrors, UpdateMeResponses, UpdateMileageEntryData, UpdateMileageEntryErrors, UpdateMileageEntryResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses, UpdateProjectStatusData, UpdateProjectStatusErrors, UpdateProjectStatusResponses, UpdateQuoteData, UpdateQuoteErrors, UpdateQuoteResponses, UpdateRecurringInvoiceData, UpdateRecurringInvoiceErrors, UpdateRecurringInvoiceResponses, UpdateRecurringTaskRuleData, UpdateRecurringTaskRuleErrors, UpdateRecurringTaskRuleResponses, UpdateReportViewData, UpdateReportViewErrors, UpdateReportViewResponses, UpdateTaskData, UpdateTaskErrors, UpdateTaskResponses, UpdateTaxSetAsideEntryData, UpdateTaxSetAsideEntryErrors, UpdateTaxSetAsideEntryResponses, UpdateTimeEntryData, UpdateTimeEntryErrors, UpdateTimeEntryResponses, UpdateTimeEntryTagData, UpdateTimeEntryTagErrors, UpdateTimeEntryTagResponses, UpdateUserRateData, UpdateUserRateErrors, UpdateUserRateResponses, UpdateWorkspaceData, UpdateWorkspaceErrors, UpdateWorkspaceMemberData, UpdateWorkspaceMemberErrors, UpdateWorkspaceMemberResponses, UpdateWorkspaceResponses, VerifyMagicLinkData, VerifyMagicLinkErrors, VerifyMagicLinkResponses, VerifyMfaData, VerifyMfaErrors, VerifyMfaResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Cancel a scheduled deletion
 */
export const cancelAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<CancelAccountDeletionData, ThrowOnError>): RequestResult<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).delete<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Current deletion request, if any
 */
export const getAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<GetAccountDeletionData, ThrowOnError>): RequestResult<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Schedule the account for deletion
 */
export const requestAccountDeletion = <ThrowOnError extends boolean = false>(options: Options<RequestAccountDeletionData, ThrowOnError>): RequestResult<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError> => (options.client ?? client).post<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export all of the user's data
 */
export const exportAccount = <ThrowOnError extends boolean = false>(options?: Options<ExportAccountData, ThrowOnError>): RequestResult<ExportAccountResponses, ExportAccountErrors, ThrowOnError> => (options?.client ?? client).get<ExportAccountResponses, ExportAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/export',
    ...options
});

/**
 * List AssetDepreciationEntry rows
 */
export const listAssetDepreciationEntrys = <ThrowOnError extends boolean = false>(options?: Options<ListAssetDepreciationEntrysData, ThrowOnError>): RequestResult<ListAssetDepreciationEntrysResponses, ListAssetDepreciationEntrysErrors, ThrowOnError> => (options?.client ?? client).get<ListAssetDepreciationEntrysResponses, ListAssetDepreciationEntrysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/asset-depreciation-entries',
    ...options
});

/**
 * Create a AssetDepreciationEntry
 */
export const createAssetDepreciationEntry = <ThrowOnError extends boolean = false>(options: Options<CreateAssetDepreciationEntryData, ThrowOnError>): RequestResult<CreateAssetDepreciationEntryResponses, CreateAssetDepreciationEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateAssetDepreciationEntryResponses, CreateAssetDepreciationEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/asset-depreciation-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a AssetDepreciationEntry
 */
export const deleteAssetDepreciationEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteAssetDepreciationEntryData, ThrowOnError>): RequestResult<DeleteAssetDepreciationEntryResponses, DeleteAssetDepreciationEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAssetDepreciationEntryResponses, DeleteAssetDepreciationEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/asset-depreciation-entries/{id}',
    ...options
});

/**
 * Get one AssetDepreciationEntry
 */
export const getAssetDepreciationEntry = <ThrowOnError extends boolean = false>(options: Options<GetAssetDepreciationEntryData, ThrowOnError>): RequestResult<GetAssetDepreciationEntryResponses, GetAssetDepreciationEntryErrors, ThrowOnError> => (options.client ?? client).get<GetAssetDepreciationEntryResponses, GetAssetDepreciationEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/asset-depreciation-entries/{id}',
    ...options
});

/**
 * Update a AssetDepreciationEntry
 */
export const updateAssetDepreciationEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateAssetDepreciationEntryData, ThrowOnError>): RequestResult<UpdateAssetDepreciationEntryResponses, UpdateAssetDepreciationEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAssetDepreciationEntryResponses, UpdateAssetDepreciationEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/asset-depreciation-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an email address
 */
export const confirmEmail = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailData, ThrowOnError>): RequestResult<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError>({
    url: '/v1/auth/email/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the confirmation email
 */
export const resendConfirmation = <ThrowOnError extends boolean = false>(options: Options<ResendConfirmationData, ThrowOnError>): RequestResult<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError> => (options.client ?? client).post<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError>({
    url: '/v1/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signed-in user
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options
});

/**
 * Update the signed-in user
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn off two-factor authentication (needs an MFA-verified session)
 */
export const disableMfa = <ThrowOnError extends boolean = false>(options?: Options<DisableMfaData, ThrowOnError>): RequestResult<DisableMfaResponses, DisableMfaErrors, ThrowOnError> => (options?.client ?? client).post<DisableMfaResponses, DisableMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/disable',
    ...options
});

/**
 * Begin two-factor enrolment
 */
export const enrollMfa = <ThrowOnError extends boolean = false>(options?: Options<EnrollMfaData, ThrowOnError>): RequestResult<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError> => (options?.client ?? client).post<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll',
    ...options
});

/**
 * Confirm enrolment with a code
 */
export const confirmMfaEnrollment = <ThrowOnError extends boolean = false>(options: Options<ConfirmMfaEnrollmentData, ThrowOnError>): RequestResult<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish a two-factor sign-in
 */
export const verifyMfa = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaData, ThrowOnError>): RequestResult<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError> => (options.client ?? client).post<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError>({
    url: '/v1/auth/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a sign-in link
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(options: Options<RequestMagicLinkData, ThrowOnError>): RequestResult<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with an emailed token
 */
export const verifyMagicLink = <ThrowOnError extends boolean = false>(options: Options<VerifyMagicLinkData, ThrowOnError>): RequestResult<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change password
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a password reset link
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password using an emailed token
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the refresh token
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 */
export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>): RequestResult<SignInResponses, SignInErrors, ThrowOnError> => (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: '/v1/auth/sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke the current session
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError> => (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/sign-out',
    ...options
});

/**
 * Create an account
 */
export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: '/v1/auth/sign-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run budget-alerts now
 */
export const evaluateBudgetAlerts = <ThrowOnError extends boolean = false>(options: Options<EvaluateBudgetAlertsData, ThrowOnError>): RequestResult<EvaluateBudgetAlertsResponses, EvaluateBudgetAlertsErrors, ThrowOnError> => (options.client ?? client).post<EvaluateBudgetAlertsResponses, EvaluateBudgetAlertsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/automation/budget-alerts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run invoice-reminders now
 */
export const sendInvoiceReminders = <ThrowOnError extends boolean = false>(options: Options<SendInvoiceRemindersData, ThrowOnError>): RequestResult<SendInvoiceRemindersResponses, SendInvoiceRemindersErrors, ThrowOnError> => (options.client ?? client).post<SendInvoiceRemindersResponses, SendInvoiceRemindersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/automation/invoice-reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run recurring-invoices now
 */
export const runRecurringInvoices = <ThrowOnError extends boolean = false>(options: Options<RunRecurringInvoicesData, ThrowOnError>): RequestResult<RunRecurringInvoicesResponses, RunRecurringInvoicesErrors, ThrowOnError> => (options.client ?? client).post<RunRecurringInvoicesResponses, RunRecurringInvoicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/automation/recurring-invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run recurring-tasks now
 */
export const runRecurringTasks = <ThrowOnError extends boolean = false>(options: Options<RunRecurringTasksData, ThrowOnError>): RequestResult<RunRecurringTasksResponses, RunRecurringTasksErrors, ThrowOnError> => (options.client ?? client).post<RunRecurringTasksResponses, RunRecurringTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/automation/recurring-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run scheduled-sends now
 */
export const sendScheduledDocuments = <ThrowOnError extends boolean = false>(options: Options<SendScheduledDocumentsData, ThrowOnError>): RequestResult<SendScheduledDocumentsResponses, SendScheduledDocumentsErrors, ThrowOnError> => (options.client ?? client).post<SendScheduledDocumentsResponses, SendScheduledDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/automation/scheduled-sends',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Client rows
 */
export const listClients = <ThrowOnError extends boolean = false>(options?: Options<ListClientsData, ThrowOnError>): RequestResult<ListClientsResponses, ListClientsErrors, ThrowOnError> => (options?.client ?? client).get<ListClientsResponses, ListClientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/clients',
    ...options
});

/**
 * Create a Client
 */
export const createClient = <ThrowOnError extends boolean = false>(options: Options<CreateClientData, ThrowOnError>): RequestResult<CreateClientResponses, CreateClientErrors, ThrowOnError> => (options.client ?? client).post<CreateClientResponses, CreateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Client
 */
export const deleteClient = <ThrowOnError extends boolean = false>(options: Options<DeleteClientData, ThrowOnError>): RequestResult<DeleteClientResponses, DeleteClientErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClientResponses, DeleteClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/clients/{id}',
    ...options
});

/**
 * Get one Client
 */
export const getClient = <ThrowOnError extends boolean = false>(options: Options<GetClientData, ThrowOnError>): RequestResult<GetClientResponses, GetClientErrors, ThrowOnError> => (options.client ?? client).get<GetClientResponses, GetClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/clients/{id}',
    ...options
});

/**
 * Update a Client
 */
export const updateClient = <ThrowOnError extends boolean = false>(options: Options<UpdateClientData, ThrowOnError>): RequestResult<UpdateClientResponses, UpdateClientErrors, ThrowOnError> => (options.client ?? client).patch<UpdateClientResponses, UpdateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/clients/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a contact message
 */
export const submitContact = <ThrowOnError extends boolean = false>(options: Options<SubmitContactData, ThrowOnError>): RequestResult<SubmitContactResponses, SubmitContactErrors, ThrowOnError> => (options.client ?? client).post<SubmitContactResponses, SubmitContactErrors, ThrowOnError>({
    url: '/v1/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register this device for push notifications
 */
export const registerDevicePushToken = <ThrowOnError extends boolean = false>(options: Options<RegisterDevicePushTokenData, ThrowOnError>): RequestResult<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError> => (options.client ?? client).put<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/device-push-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List ExpenseCategory rows
 */
export const listExpenseCategorys = <ThrowOnError extends boolean = false>(options?: Options<ListExpenseCategorysData, ThrowOnError>): RequestResult<ListExpenseCategorysResponses, ListExpenseCategorysErrors, ThrowOnError> => (options?.client ?? client).get<ListExpenseCategorysResponses, ListExpenseCategorysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expense-categories',
    ...options
});

/**
 * Create a ExpenseCategory
 */
export const createExpenseCategory = <ThrowOnError extends boolean = false>(options: Options<CreateExpenseCategoryData, ThrowOnError>): RequestResult<CreateExpenseCategoryResponses, CreateExpenseCategoryErrors, ThrowOnError> => (options.client ?? client).post<CreateExpenseCategoryResponses, CreateExpenseCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expense-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a ExpenseCategory
 */
export const deleteExpenseCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteExpenseCategoryData, ThrowOnError>): RequestResult<DeleteExpenseCategoryResponses, DeleteExpenseCategoryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteExpenseCategoryResponses, DeleteExpenseCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expense-categories/{id}',
    ...options
});

/**
 * Get one ExpenseCategory
 */
export const getExpenseCategory = <ThrowOnError extends boolean = false>(options: Options<GetExpenseCategoryData, ThrowOnError>): RequestResult<GetExpenseCategoryResponses, GetExpenseCategoryErrors, ThrowOnError> => (options.client ?? client).get<GetExpenseCategoryResponses, GetExpenseCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expense-categories/{id}',
    ...options
});

/**
 * Update a ExpenseCategory
 */
export const updateExpenseCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateExpenseCategoryData, ThrowOnError>): RequestResult<UpdateExpenseCategoryResponses, UpdateExpenseCategoryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateExpenseCategoryResponses, UpdateExpenseCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expense-categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Expense rows
 */
export const listExpenses = <ThrowOnError extends boolean = false>(options?: Options<ListExpensesData, ThrowOnError>): RequestResult<ListExpensesResponses, ListExpensesErrors, ThrowOnError> => (options?.client ?? client).get<ListExpensesResponses, ListExpensesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expenses',
    ...options
});

/**
 * Create a Expense
 */
export const createExpense = <ThrowOnError extends boolean = false>(options: Options<CreateExpenseData, ThrowOnError>): RequestResult<CreateExpenseResponses, CreateExpenseErrors, ThrowOnError> => (options.client ?? client).post<CreateExpenseResponses, CreateExpenseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expenses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Expense
 */
export const deleteExpense = <ThrowOnError extends boolean = false>(options: Options<DeleteExpenseData, ThrowOnError>): RequestResult<DeleteExpenseResponses, DeleteExpenseErrors, ThrowOnError> => (options.client ?? client).delete<DeleteExpenseResponses, DeleteExpenseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expenses/{id}',
    ...options
});

/**
 * Get one Expense
 */
export const getExpense = <ThrowOnError extends boolean = false>(options: Options<GetExpenseData, ThrowOnError>): RequestResult<GetExpenseResponses, GetExpenseErrors, ThrowOnError> => (options.client ?? client).get<GetExpenseResponses, GetExpenseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expenses/{id}',
    ...options
});

/**
 * Update a Expense
 */
export const updateExpense = <ThrowOnError extends boolean = false>(options: Options<UpdateExpenseData, ThrowOnError>): RequestResult<UpdateExpenseResponses, UpdateExpenseErrors, ThrowOnError> => (options.client ?? client).patch<UpdateExpenseResponses, UpdateExpenseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/expenses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send feedback
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    url: '/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List FixedAsset rows
 */
export const listFixedAssets = <ThrowOnError extends boolean = false>(options?: Options<ListFixedAssetsData, ThrowOnError>): RequestResult<ListFixedAssetsResponses, ListFixedAssetsErrors, ThrowOnError> => (options?.client ?? client).get<ListFixedAssetsResponses, ListFixedAssetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/fixed-assets',
    ...options
});

/**
 * Create a FixedAsset
 */
export const createFixedAsset = <ThrowOnError extends boolean = false>(options: Options<CreateFixedAssetData, ThrowOnError>): RequestResult<CreateFixedAssetResponses, CreateFixedAssetErrors, ThrowOnError> => (options.client ?? client).post<CreateFixedAssetResponses, CreateFixedAssetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/fixed-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a FixedAsset
 */
export const deleteFixedAsset = <ThrowOnError extends boolean = false>(options: Options<DeleteFixedAssetData, ThrowOnError>): RequestResult<DeleteFixedAssetResponses, DeleteFixedAssetErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFixedAssetResponses, DeleteFixedAssetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/fixed-assets/{id}',
    ...options
});

/**
 * Get one FixedAsset
 */
export const getFixedAsset = <ThrowOnError extends boolean = false>(options: Options<GetFixedAssetData, ThrowOnError>): RequestResult<GetFixedAssetResponses, GetFixedAssetErrors, ThrowOnError> => (options.client ?? client).get<GetFixedAssetResponses, GetFixedAssetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/fixed-assets/{id}',
    ...options
});

/**
 * Update a FixedAsset
 */
export const updateFixedAsset = <ThrowOnError extends boolean = false>(options: Options<UpdateFixedAssetData, ThrowOnError>): RequestResult<UpdateFixedAssetResponses, UpdateFixedAssetErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFixedAssetResponses, UpdateFixedAssetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/fixed-assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liveness and database check
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({ url: '/v1/health', ...options });

/**
 * List InvoiceAmendment rows
 */
export const listInvoiceAmendments = <ThrowOnError extends boolean = false>(options?: Options<ListInvoiceAmendmentsData, ThrowOnError>): RequestResult<ListInvoiceAmendmentsResponses, ListInvoiceAmendmentsErrors, ThrowOnError> => (options?.client ?? client).get<ListInvoiceAmendmentsResponses, ListInvoiceAmendmentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-amendments',
    ...options
});

/**
 * Get one InvoiceAmendment
 */
export const getInvoiceAmendment = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceAmendmentData, ThrowOnError>): RequestResult<GetInvoiceAmendmentResponses, GetInvoiceAmendmentErrors, ThrowOnError> => (options.client ?? client).get<GetInvoiceAmendmentResponses, GetInvoiceAmendmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-amendments/{id}',
    ...options
});

/**
 * List InvoiceItem rows
 */
export const listInvoiceItems = <ThrowOnError extends boolean = false>(options?: Options<ListInvoiceItemsData, ThrowOnError>): RequestResult<ListInvoiceItemsResponses, ListInvoiceItemsErrors, ThrowOnError> => (options?.client ?? client).get<ListInvoiceItemsResponses, ListInvoiceItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-items',
    ...options
});

/**
 * Create a InvoiceItem
 */
export const createInvoiceItem = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceItemData, ThrowOnError>): RequestResult<CreateInvoiceItemResponses, CreateInvoiceItemErrors, ThrowOnError> => (options.client ?? client).post<CreateInvoiceItemResponses, CreateInvoiceItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a InvoiceItem
 */
export const deleteInvoiceItem = <ThrowOnError extends boolean = false>(options: Options<DeleteInvoiceItemData, ThrowOnError>): RequestResult<DeleteInvoiceItemResponses, DeleteInvoiceItemErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvoiceItemResponses, DeleteInvoiceItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-items/{id}',
    ...options
});

/**
 * Get one InvoiceItem
 */
export const getInvoiceItem = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceItemData, ThrowOnError>): RequestResult<GetInvoiceItemResponses, GetInvoiceItemErrors, ThrowOnError> => (options.client ?? client).get<GetInvoiceItemResponses, GetInvoiceItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-items/{id}',
    ...options
});

/**
 * Update a InvoiceItem
 */
export const updateInvoiceItem = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceItemData, ThrowOnError>): RequestResult<UpdateInvoiceItemResponses, UpdateInvoiceItemErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceItemResponses, UpdateInvoiceItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-items/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List InvoicePayment rows
 */
export const listInvoicePayments = <ThrowOnError extends boolean = false>(options?: Options<ListInvoicePaymentsData, ThrowOnError>): RequestResult<ListInvoicePaymentsResponses, ListInvoicePaymentsErrors, ThrowOnError> => (options?.client ?? client).get<ListInvoicePaymentsResponses, ListInvoicePaymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-payments',
    ...options
});

/**
 * Get one InvoicePayment
 */
export const getInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<GetInvoicePaymentData, ThrowOnError>): RequestResult<GetInvoicePaymentResponses, GetInvoicePaymentErrors, ThrowOnError> => (options.client ?? client).get<GetInvoicePaymentResponses, GetInvoicePaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-payments/{id}',
    ...options
});

/**
 * List InvoiceRefund rows
 */
export const listInvoiceRefunds = <ThrowOnError extends boolean = false>(options?: Options<ListInvoiceRefundsData, ThrowOnError>): RequestResult<ListInvoiceRefundsResponses, ListInvoiceRefundsErrors, ThrowOnError> => (options?.client ?? client).get<ListInvoiceRefundsResponses, ListInvoiceRefundsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-refunds',
    ...options
});

/**
 * Get one InvoiceRefund
 */
export const getInvoiceRefund = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceRefundData, ThrowOnError>): RequestResult<GetInvoiceRefundResponses, GetInvoiceRefundErrors, ThrowOnError> => (options.client ?? client).get<GetInvoiceRefundResponses, GetInvoiceRefundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-refunds/{id}',
    ...options
});

/**
 * List InvoiceReminder rows
 */
export const listInvoiceReminders = <ThrowOnError extends boolean = false>(options?: Options<ListInvoiceRemindersData, ThrowOnError>): RequestResult<ListInvoiceRemindersResponses, ListInvoiceRemindersErrors, ThrowOnError> => (options?.client ?? client).get<ListInvoiceRemindersResponses, ListInvoiceRemindersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-reminders',
    ...options
});

/**
 * Create a InvoiceReminder
 */
export const createInvoiceReminder = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceReminderData, ThrowOnError>): RequestResult<CreateInvoiceReminderResponses, CreateInvoiceReminderErrors, ThrowOnError> => (options.client ?? client).post<CreateInvoiceReminderResponses, CreateInvoiceReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a InvoiceReminder
 */
export const deleteInvoiceReminder = <ThrowOnError extends boolean = false>(options: Options<DeleteInvoiceReminderData, ThrowOnError>): RequestResult<DeleteInvoiceReminderResponses, DeleteInvoiceReminderErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvoiceReminderResponses, DeleteInvoiceReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-reminders/{id}',
    ...options
});

/**
 * Get one InvoiceReminder
 */
export const getInvoiceReminder = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceReminderData, ThrowOnError>): RequestResult<GetInvoiceReminderResponses, GetInvoiceReminderErrors, ThrowOnError> => (options.client ?? client).get<GetInvoiceReminderResponses, GetInvoiceReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-reminders/{id}',
    ...options
});

/**
 * Update a InvoiceReminder
 */
export const updateInvoiceReminder = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceReminderData, ThrowOnError>): RequestResult<UpdateInvoiceReminderResponses, UpdateInvoiceReminderErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceReminderResponses, UpdateInvoiceReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoice-reminders/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Invoice rows
 */
export const listInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListInvoicesData, ThrowOnError>): RequestResult<ListInvoicesResponses, ListInvoicesErrors, ThrowOnError> => (options?.client ?? client).get<ListInvoicesResponses, ListInvoicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices',
    ...options
});

/**
 * Create a Invoice
 */
export const createInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceData, ThrowOnError>): RequestResult<CreateInvoiceResponses, CreateInvoiceErrors, ThrowOnError> => (options.client ?? client).post<CreateInvoiceResponses, CreateInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Invoice
 */
export const deleteInvoice = <ThrowOnError extends boolean = false>(options: Options<DeleteInvoiceData, ThrowOnError>): RequestResult<DeleteInvoiceResponses, DeleteInvoiceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvoiceResponses, DeleteInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}',
    ...options
});

/**
 * Get one Invoice
 */
export const getInvoice = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceData, ThrowOnError>): RequestResult<GetInvoiceResponses, GetInvoiceErrors, ThrowOnError> => (options.client ?? client).get<GetInvoiceResponses, GetInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}',
    ...options
});

/**
 * Update a Invoice
 */
export const updateInvoice = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceData, ThrowOnError>): RequestResult<UpdateInvoiceResponses, UpdateInvoiceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvoiceResponses, UpdateInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit due date, client and notes, optionally recording an amendment
 */
export const updateInvoiceDetails = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceDetailsData, ThrowOnError>): RequestResult<UpdateInvoiceDetailsResponses, UpdateInvoiceDetailsErrors, ThrowOnError> => (options.client ?? client).post<UpdateInvoiceDetailsResponses, UpdateInvoiceDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-bill an expense on this invoice
 */
export const addExpenseToInvoice = <ThrowOnError extends boolean = false>(options: Options<AddExpenseToInvoiceData, ThrowOnError>): RequestResult<AddExpenseToInvoiceResponses, AddExpenseToInvoiceErrors, ThrowOnError> => (options.client ?? client).post<AddExpenseToInvoiceResponses, AddExpenseToInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/expense-item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record a payment
 */
export const recordInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<RecordInvoicePaymentData, ThrowOnError>): RequestResult<RecordInvoicePaymentResponses, RecordInvoicePaymentErrors, ThrowOnError> => (options.client ?? client).post<RecordInvoicePaymentResponses, RecordInvoicePaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The link a client can open
 */
export const issueInvoiceLink = <ThrowOnError extends boolean = false>(options: Options<IssueInvoiceLinkData, ThrowOnError>): RequestResult<IssueInvoiceLinkResponses, IssueInvoiceLinkErrors, ThrowOnError> => (options.client ?? client).post<IssueInvoiceLinkResponses, IssueInvoiceLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/public-link',
    ...options
});

/**
 * Record a refund
 */
export const recordInvoiceRefund = <ThrowOnError extends boolean = false>(options: Options<RecordInvoiceRefundData, ThrowOnError>): RequestResult<RecordInvoiceRefundResponses, RecordInvoiceRefundErrors, ThrowOnError> => (options.client ?? client).post<RecordInvoiceRefundResponses, RecordInvoiceRefundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/refunds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email the invoice to the client
 */
export const sendInvoiceEmail = <ThrowOnError extends boolean = false>(options: Options<SendInvoiceEmailData, ThrowOnError>): RequestResult<SendInvoiceEmailResponses, SendInvoiceEmailErrors, ThrowOnError> => (options.client ?? client).post<SendInvoiceEmailResponses, SendInvoiceEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/send',
    ...options
});

/**
 * Bill a time entry on this invoice
 */
export const addTimeEntryToInvoice = <ThrowOnError extends boolean = false>(options: Options<AddTimeEntryToInvoiceData, ThrowOnError>): RequestResult<AddTimeEntryToInvoiceResponses, AddTimeEntryToInvoiceErrors, ThrowOnError> => (options.client ?? client).post<AddTimeEntryToInvoiceResponses, AddTimeEntryToInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/invoices/{id}/time-entry-item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List MileageEntry rows
 */
export const listMileageEntrys = <ThrowOnError extends boolean = false>(options?: Options<ListMileageEntrysData, ThrowOnError>): RequestResult<ListMileageEntrysResponses, ListMileageEntrysErrors, ThrowOnError> => (options?.client ?? client).get<ListMileageEntrysResponses, ListMileageEntrysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mileage-entries',
    ...options
});

/**
 * Create a MileageEntry
 */
export const createMileageEntry = <ThrowOnError extends boolean = false>(options: Options<CreateMileageEntryData, ThrowOnError>): RequestResult<CreateMileageEntryResponses, CreateMileageEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateMileageEntryResponses, CreateMileageEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mileage-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a MileageEntry
 */
export const deleteMileageEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteMileageEntryData, ThrowOnError>): RequestResult<DeleteMileageEntryResponses, DeleteMileageEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMileageEntryResponses, DeleteMileageEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mileage-entries/{id}',
    ...options
});

/**
 * Get one MileageEntry
 */
export const getMileageEntry = <ThrowOnError extends boolean = false>(options: Options<GetMileageEntryData, ThrowOnError>): RequestResult<GetMileageEntryResponses, GetMileageEntryErrors, ThrowOnError> => (options.client ?? client).get<GetMileageEntryResponses, GetMileageEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mileage-entries/{id}',
    ...options
});

/**
 * Update a MileageEntry
 */
export const updateMileageEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateMileageEntryData, ThrowOnError>): RequestResult<UpdateMileageEntryResponses, UpdateMileageEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMileageEntryResponses, UpdateMileageEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mileage-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notifications for the signed-in person
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>): RequestResult<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/notifications',
    ...options
});

/**
 * Mark one notification read
 */
export const markNotificationRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationReadData, ThrowOnError>): RequestResult<MarkNotificationReadResponses, MarkNotificationReadErrors, ThrowOnError> => (options.client ?? client).put<MarkNotificationReadResponses, MarkNotificationReadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/notifications/{id}/read',
    ...options
});

/**
 * List ProjectStatus rows
 */
export const listProjectStatuss = <ThrowOnError extends boolean = false>(options?: Options<ListProjectStatussData, ThrowOnError>): RequestResult<ListProjectStatussResponses, ListProjectStatussErrors, ThrowOnError> => (options?.client ?? client).get<ListProjectStatussResponses, ListProjectStatussErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/project-statuses',
    ...options
});

/**
 * Create a ProjectStatus
 */
export const createProjectStatus = <ThrowOnError extends boolean = false>(options: Options<CreateProjectStatusData, ThrowOnError>): RequestResult<CreateProjectStatusResponses, CreateProjectStatusErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectStatusResponses, CreateProjectStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/project-statuses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a ProjectStatus
 */
export const deleteProjectStatus = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectStatusData, ThrowOnError>): RequestResult<DeleteProjectStatusResponses, DeleteProjectStatusErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectStatusResponses, DeleteProjectStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/project-statuses/{id}',
    ...options
});

/**
 * Get one ProjectStatus
 */
export const getProjectStatus = <ThrowOnError extends boolean = false>(options: Options<GetProjectStatusData, ThrowOnError>): RequestResult<GetProjectStatusResponses, GetProjectStatusErrors, ThrowOnError> => (options.client ?? client).get<GetProjectStatusResponses, GetProjectStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/project-statuses/{id}',
    ...options
});

/**
 * Update a ProjectStatus
 */
export const updateProjectStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectStatusData, ThrowOnError>): RequestResult<UpdateProjectStatusResponses, UpdateProjectStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectStatusResponses, UpdateProjectStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/project-statuses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Project rows
 */
export const listProjects = <ThrowOnError extends boolean = false>(options?: Options<ListProjectsData, ThrowOnError>): RequestResult<ListProjectsResponses, ListProjectsErrors, ThrowOnError> => (options?.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects',
    ...options
});

/**
 * Create a Project
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}',
    ...options
});

/**
 * Get one Project
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> => (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}',
    ...options
});

/**
 * Update a Project
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * An invoice, from its client link
 */
export const getPublicInvoice = <ThrowOnError extends boolean = false>(options: Options<GetPublicInvoiceData, ThrowOnError>): RequestResult<GetPublicInvoiceResponses, GetPublicInvoiceErrors, ThrowOnError> => (options.client ?? client).get<GetPublicInvoiceResponses, GetPublicInvoiceErrors, ThrowOnError>({ url: '/v1/public/invoices/{token}', ...options });

/**
 * A quote, from its client link
 */
export const getPublicQuote = <ThrowOnError extends boolean = false>(options: Options<GetPublicQuoteData, ThrowOnError>): RequestResult<GetPublicQuoteResponses, GetPublicQuoteErrors, ThrowOnError> => (options.client ?? client).get<GetPublicQuoteResponses, GetPublicQuoteErrors, ThrowOnError>({ url: '/v1/public/quotes/{token}', ...options });

/**
 * Accept or decline a quote
 */
export const respondToPublicQuote = <ThrowOnError extends boolean = false>(options: Options<RespondToPublicQuoteData, ThrowOnError>): RequestResult<RespondToPublicQuoteResponses, RespondToPublicQuoteErrors, ThrowOnError> => (options.client ?? client).post<RespondToPublicQuoteResponses, RespondToPublicQuoteErrors, ThrowOnError>({
    url: '/v1/public/quotes/{token}/respond',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List QuoteItem rows
 */
export const listQuoteItems = <ThrowOnError extends boolean = false>(options?: Options<ListQuoteItemsData, ThrowOnError>): RequestResult<ListQuoteItemsResponses, ListQuoteItemsErrors, ThrowOnError> => (options?.client ?? client).get<ListQuoteItemsResponses, ListQuoteItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quote-items',
    ...options
});

/**
 * Get one QuoteItem
 */
export const getQuoteItem = <ThrowOnError extends boolean = false>(options: Options<GetQuoteItemData, ThrowOnError>): RequestResult<GetQuoteItemResponses, GetQuoteItemErrors, ThrowOnError> => (options.client ?? client).get<GetQuoteItemResponses, GetQuoteItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quote-items/{id}',
    ...options
});

/**
 * List Quote rows
 */
export const listQuotes = <ThrowOnError extends boolean = false>(options?: Options<ListQuotesData, ThrowOnError>): RequestResult<ListQuotesResponses, ListQuotesErrors, ThrowOnError> => (options?.client ?? client).get<ListQuotesResponses, ListQuotesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes',
    ...options
});

/**
 * Create a Quote
 */
export const createQuote = <ThrowOnError extends boolean = false>(options: Options<CreateQuoteData, ThrowOnError>): RequestResult<CreateQuoteResponses, CreateQuoteErrors, ThrowOnError> => (options.client ?? client).post<CreateQuoteResponses, CreateQuoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Quote
 */
export const deleteQuote = <ThrowOnError extends boolean = false>(options: Options<DeleteQuoteData, ThrowOnError>): RequestResult<DeleteQuoteResponses, DeleteQuoteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteQuoteResponses, DeleteQuoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes/{id}',
    ...options
});

/**
 * Get one Quote
 */
export const getQuote = <ThrowOnError extends boolean = false>(options: Options<GetQuoteData, ThrowOnError>): RequestResult<GetQuoteResponses, GetQuoteErrors, ThrowOnError> => (options.client ?? client).get<GetQuoteResponses, GetQuoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes/{id}',
    ...options
});

/**
 * Update a Quote
 */
export const updateQuote = <ThrowOnError extends boolean = false>(options: Options<UpdateQuoteData, ThrowOnError>): RequestResult<UpdateQuoteResponses, UpdateQuoteErrors, ThrowOnError> => (options.client ?? client).patch<UpdateQuoteResponses, UpdateQuoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn an accepted quote into a draft invoice
 */
export const convertQuoteToInvoice = <ThrowOnError extends boolean = false>(options: Options<ConvertQuoteToInvoiceData, ThrowOnError>): RequestResult<ConvertQuoteToInvoiceResponses, ConvertQuoteToInvoiceErrors, ThrowOnError> => (options.client ?? client).post<ConvertQuoteToInvoiceResponses, ConvertQuoteToInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes/{id}/convert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The link a client can open
 */
export const issueQuoteLink = <ThrowOnError extends boolean = false>(options: Options<IssueQuoteLinkData, ThrowOnError>): RequestResult<IssueQuoteLinkResponses, IssueQuoteLinkErrors, ThrowOnError> => (options.client ?? client).post<IssueQuoteLinkResponses, IssueQuoteLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes/{id}/public-link',
    ...options
});

/**
 * Email the quote to the client
 */
export const sendQuoteEmail = <ThrowOnError extends boolean = false>(options: Options<SendQuoteEmailData, ThrowOnError>): RequestResult<SendQuoteEmailResponses, SendQuoteEmailErrors, ThrowOnError> => (options.client ?? client).post<SendQuoteEmailResponses, SendQuoteEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/quotes/{id}/send',
    ...options
});

/**
 * List RecurringInvoice rows
 */
export const listRecurringInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListRecurringInvoicesData, ThrowOnError>): RequestResult<ListRecurringInvoicesResponses, ListRecurringInvoicesErrors, ThrowOnError> => (options?.client ?? client).get<ListRecurringInvoicesResponses, ListRecurringInvoicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-invoices',
    ...options
});

/**
 * Create a RecurringInvoice
 */
export const createRecurringInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateRecurringInvoiceData, ThrowOnError>): RequestResult<CreateRecurringInvoiceResponses, CreateRecurringInvoiceErrors, ThrowOnError> => (options.client ?? client).post<CreateRecurringInvoiceResponses, CreateRecurringInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a RecurringInvoice
 */
export const deleteRecurringInvoice = <ThrowOnError extends boolean = false>(options: Options<DeleteRecurringInvoiceData, ThrowOnError>): RequestResult<DeleteRecurringInvoiceResponses, DeleteRecurringInvoiceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRecurringInvoiceResponses, DeleteRecurringInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-invoices/{id}',
    ...options
});

/**
 * Get one RecurringInvoice
 */
export const getRecurringInvoice = <ThrowOnError extends boolean = false>(options: Options<GetRecurringInvoiceData, ThrowOnError>): RequestResult<GetRecurringInvoiceResponses, GetRecurringInvoiceErrors, ThrowOnError> => (options.client ?? client).get<GetRecurringInvoiceResponses, GetRecurringInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-invoices/{id}',
    ...options
});

/**
 * Update a RecurringInvoice
 */
export const updateRecurringInvoice = <ThrowOnError extends boolean = false>(options: Options<UpdateRecurringInvoiceData, ThrowOnError>): RequestResult<UpdateRecurringInvoiceResponses, UpdateRecurringInvoiceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRecurringInvoiceResponses, UpdateRecurringInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-invoices/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List RecurringTaskRule rows
 */
export const listRecurringTaskRules = <ThrowOnError extends boolean = false>(options?: Options<ListRecurringTaskRulesData, ThrowOnError>): RequestResult<ListRecurringTaskRulesResponses, ListRecurringTaskRulesErrors, ThrowOnError> => (options?.client ?? client).get<ListRecurringTaskRulesResponses, ListRecurringTaskRulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-task-rules',
    ...options
});

/**
 * Create a RecurringTaskRule
 */
export const createRecurringTaskRule = <ThrowOnError extends boolean = false>(options: Options<CreateRecurringTaskRuleData, ThrowOnError>): RequestResult<CreateRecurringTaskRuleResponses, CreateRecurringTaskRuleErrors, ThrowOnError> => (options.client ?? client).post<CreateRecurringTaskRuleResponses, CreateRecurringTaskRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-task-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a RecurringTaskRule
 */
export const deleteRecurringTaskRule = <ThrowOnError extends boolean = false>(options: Options<DeleteRecurringTaskRuleData, ThrowOnError>): RequestResult<DeleteRecurringTaskRuleResponses, DeleteRecurringTaskRuleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRecurringTaskRuleResponses, DeleteRecurringTaskRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-task-rules/{id}',
    ...options
});

/**
 * Get one RecurringTaskRule
 */
export const getRecurringTaskRule = <ThrowOnError extends boolean = false>(options: Options<GetRecurringTaskRuleData, ThrowOnError>): RequestResult<GetRecurringTaskRuleResponses, GetRecurringTaskRuleErrors, ThrowOnError> => (options.client ?? client).get<GetRecurringTaskRuleResponses, GetRecurringTaskRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-task-rules/{id}',
    ...options
});

/**
 * Update a RecurringTaskRule
 */
export const updateRecurringTaskRule = <ThrowOnError extends boolean = false>(options: Options<UpdateRecurringTaskRuleData, ThrowOnError>): RequestResult<UpdateRecurringTaskRuleResponses, UpdateRecurringTaskRuleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRecurringTaskRuleResponses, UpdateRecurringTaskRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recurring-task-rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List ReportView rows
 */
export const listReportViews = <ThrowOnError extends boolean = false>(options?: Options<ListReportViewsData, ThrowOnError>): RequestResult<ListReportViewsResponses, ListReportViewsErrors, ThrowOnError> => (options?.client ?? client).get<ListReportViewsResponses, ListReportViewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report-views',
    ...options
});

/**
 * Create a ReportView
 */
export const createReportView = <ThrowOnError extends boolean = false>(options: Options<CreateReportViewData, ThrowOnError>): RequestResult<CreateReportViewResponses, CreateReportViewErrors, ThrowOnError> => (options.client ?? client).post<CreateReportViewResponses, CreateReportViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report-views',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a ReportView
 */
export const deleteReportView = <ThrowOnError extends boolean = false>(options: Options<DeleteReportViewData, ThrowOnError>): RequestResult<DeleteReportViewResponses, DeleteReportViewErrors, ThrowOnError> => (options.client ?? client).delete<DeleteReportViewResponses, DeleteReportViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report-views/{id}',
    ...options
});

/**
 * Get one ReportView
 */
export const getReportView = <ThrowOnError extends boolean = false>(options: Options<GetReportViewData, ThrowOnError>): RequestResult<GetReportViewResponses, GetReportViewErrors, ThrowOnError> => (options.client ?? client).get<GetReportViewResponses, GetReportViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report-views/{id}',
    ...options
});

/**
 * Update a ReportView
 */
export const updateReportView = <ThrowOnError extends boolean = false>(options: Options<UpdateReportViewData, ThrowOnError>): RequestResult<UpdateReportViewResponses, UpdateReportViewErrors, ThrowOnError> => (options.client ?? client).patch<UpdateReportViewResponses, UpdateReportViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report-views/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Task rows
 */
export const listTasks = <ThrowOnError extends boolean = false>(options?: Options<ListTasksData, ThrowOnError>): RequestResult<ListTasksResponses, ListTasksErrors, ThrowOnError> => (options?.client ?? client).get<ListTasksResponses, ListTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks',
    ...options
});

/**
 * Create a Task
 */
export const createTask = <ThrowOnError extends boolean = false>(options: Options<CreateTaskData, ThrowOnError>): RequestResult<CreateTaskResponses, CreateTaskErrors, ThrowOnError> => (options.client ?? client).post<CreateTaskResponses, CreateTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Task
 */
export const deleteTask = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskData, ThrowOnError>): RequestResult<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options
});

/**
 * Get one Task
 */
export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>): RequestResult<GetTaskResponses, GetTaskErrors, ThrowOnError> => (options.client ?? client).get<GetTaskResponses, GetTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options
});

/**
 * Update a Task
 */
export const updateTask = <ThrowOnError extends boolean = false>(options: Options<UpdateTaskData, ThrowOnError>): RequestResult<UpdateTaskResponses, UpdateTaskErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTaskResponses, UpdateTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List TaxSetAsideEntry rows
 */
export const listTaxSetAsideEntrys = <ThrowOnError extends boolean = false>(options?: Options<ListTaxSetAsideEntrysData, ThrowOnError>): RequestResult<ListTaxSetAsideEntrysResponses, ListTaxSetAsideEntrysErrors, ThrowOnError> => (options?.client ?? client).get<ListTaxSetAsideEntrysResponses, ListTaxSetAsideEntrysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tax-set-aside-entries',
    ...options
});

/**
 * Create a TaxSetAsideEntry
 */
export const createTaxSetAsideEntry = <ThrowOnError extends boolean = false>(options: Options<CreateTaxSetAsideEntryData, ThrowOnError>): RequestResult<CreateTaxSetAsideEntryResponses, CreateTaxSetAsideEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateTaxSetAsideEntryResponses, CreateTaxSetAsideEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tax-set-aside-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a TaxSetAsideEntry
 */
export const deleteTaxSetAsideEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteTaxSetAsideEntryData, ThrowOnError>): RequestResult<DeleteTaxSetAsideEntryResponses, DeleteTaxSetAsideEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaxSetAsideEntryResponses, DeleteTaxSetAsideEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tax-set-aside-entries/{id}',
    ...options
});

/**
 * Get one TaxSetAsideEntry
 */
export const getTaxSetAsideEntry = <ThrowOnError extends boolean = false>(options: Options<GetTaxSetAsideEntryData, ThrowOnError>): RequestResult<GetTaxSetAsideEntryResponses, GetTaxSetAsideEntryErrors, ThrowOnError> => (options.client ?? client).get<GetTaxSetAsideEntryResponses, GetTaxSetAsideEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tax-set-aside-entries/{id}',
    ...options
});

/**
 * Update a TaxSetAsideEntry
 */
export const updateTaxSetAsideEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateTaxSetAsideEntryData, ThrowOnError>): RequestResult<UpdateTaxSetAsideEntryResponses, UpdateTaxSetAsideEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTaxSetAsideEntryResponses, UpdateTaxSetAsideEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tax-set-aside-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List my tickets
 */
export const listTickets = <ThrowOnError extends boolean = false>(options?: Options<ListTicketsData, ThrowOnError>): RequestResult<ListTicketsResponses, ListTicketsErrors, ThrowOnError> => (options?.client ?? client).get<ListTicketsResponses, ListTicketsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options
});

/**
 * Open a ticket
 */
export const createTicket = <ThrowOnError extends boolean = false>(options: Options<CreateTicketData, ThrowOnError>): RequestResult<CreateTicketResponses, CreateTicketErrors, ThrowOnError> => (options.client ?? client).post<CreateTicketResponses, CreateTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One of my tickets with its conversation
 */
export const getTicket = <ThrowOnError extends boolean = false>(options: Options<GetTicketData, ThrowOnError>): RequestResult<GetTicketResponses, GetTicketErrors, ThrowOnError> => (options.client ?? client).get<GetTicketResponses, GetTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}',
    ...options
});

/**
 * Add a note to a ticket
 */
export const addTicketMessage = <ThrowOnError extends boolean = false>(options: Options<AddTicketMessageData, ThrowOnError>): RequestResult<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError> => (options.client ?? client).post<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close or reopen a ticket
 */
export const setTicketStatus = <ThrowOnError extends boolean = false>(options: Options<SetTicketStatusData, ThrowOnError>): RequestResult<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError> => (options.client ?? client).post<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List TimeEntry rows
 */
export const listTimeEntrys = <ThrowOnError extends boolean = false>(options?: Options<ListTimeEntrysData, ThrowOnError>): RequestResult<ListTimeEntrysResponses, ListTimeEntrysErrors, ThrowOnError> => (options?.client ?? client).get<ListTimeEntrysResponses, ListTimeEntrysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entries',
    ...options
});

/**
 * Create a TimeEntry
 */
export const createTimeEntry = <ThrowOnError extends boolean = false>(options: Options<CreateTimeEntryData, ThrowOnError>): RequestResult<CreateTimeEntryResponses, CreateTimeEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateTimeEntryResponses, CreateTimeEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a TimeEntry
 */
export const deleteTimeEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteTimeEntryData, ThrowOnError>): RequestResult<DeleteTimeEntryResponses, DeleteTimeEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTimeEntryResponses, DeleteTimeEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entries/{id}',
    ...options
});

/**
 * Get one TimeEntry
 */
export const getTimeEntry = <ThrowOnError extends boolean = false>(options: Options<GetTimeEntryData, ThrowOnError>): RequestResult<GetTimeEntryResponses, GetTimeEntryErrors, ThrowOnError> => (options.client ?? client).get<GetTimeEntryResponses, GetTimeEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entries/{id}',
    ...options
});

/**
 * Update a TimeEntry
 */
export const updateTimeEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateTimeEntryData, ThrowOnError>): RequestResult<UpdateTimeEntryResponses, UpdateTimeEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTimeEntryResponses, UpdateTimeEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace the tags on a time entry
 */
export const setTimeEntryTags = <ThrowOnError extends boolean = false>(options: Options<SetTimeEntryTagsData, ThrowOnError>): RequestResult<SetTimeEntryTagsResponses, SetTimeEntryTagsErrors, ThrowOnError> => (options.client ?? client).put<SetTimeEntryTagsResponses, SetTimeEntryTagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entries/{id}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List TimeEntryTag rows
 */
export const listTimeEntryTags = <ThrowOnError extends boolean = false>(options?: Options<ListTimeEntryTagsData, ThrowOnError>): RequestResult<ListTimeEntryTagsResponses, ListTimeEntryTagsErrors, ThrowOnError> => (options?.client ?? client).get<ListTimeEntryTagsResponses, ListTimeEntryTagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entry-tags',
    ...options
});

/**
 * Create a TimeEntryTag
 */
export const createTimeEntryTag = <ThrowOnError extends boolean = false>(options: Options<CreateTimeEntryTagData, ThrowOnError>): RequestResult<CreateTimeEntryTagResponses, CreateTimeEntryTagErrors, ThrowOnError> => (options.client ?? client).post<CreateTimeEntryTagResponses, CreateTimeEntryTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entry-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a TimeEntryTag
 */
export const deleteTimeEntryTag = <ThrowOnError extends boolean = false>(options: Options<DeleteTimeEntryTagData, ThrowOnError>): RequestResult<DeleteTimeEntryTagResponses, DeleteTimeEntryTagErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTimeEntryTagResponses, DeleteTimeEntryTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entry-tags/{id}',
    ...options
});

/**
 * Get one TimeEntryTag
 */
export const getTimeEntryTag = <ThrowOnError extends boolean = false>(options: Options<GetTimeEntryTagData, ThrowOnError>): RequestResult<GetTimeEntryTagResponses, GetTimeEntryTagErrors, ThrowOnError> => (options.client ?? client).get<GetTimeEntryTagResponses, GetTimeEntryTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entry-tags/{id}',
    ...options
});

/**
 * Update a TimeEntryTag
 */
export const updateTimeEntryTag = <ThrowOnError extends boolean = false>(options: Options<UpdateTimeEntryTagData, ThrowOnError>): RequestResult<UpdateTimeEntryTagResponses, UpdateTimeEntryTagErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTimeEntryTagResponses, UpdateTimeEntryTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/time-entry-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an uploaded file
 */
export const deleteUpload = <ThrowOnError extends boolean = false>(options: Options<DeleteUploadData, ThrowOnError>): RequestResult<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/uploads',
    ...options
});

/**
 * A short-lived signed URL for an uploaded file
 */
export const getUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlData, ThrowOnError>): RequestResult<GetUploadUrlResponses, GetUploadUrlErrors, ThrowOnError> => (options.client ?? client).get<GetUploadUrlResponses, GetUploadUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/uploads/url',
    ...options
});

/**
 * List UserRate rows
 */
export const listUserRates = <ThrowOnError extends boolean = false>(options?: Options<ListUserRatesData, ThrowOnError>): RequestResult<ListUserRatesResponses, ListUserRatesErrors, ThrowOnError> => (options?.client ?? client).get<ListUserRatesResponses, ListUserRatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/user-rates',
    ...options
});

/**
 * Create a UserRate
 */
export const createUserRate = <ThrowOnError extends boolean = false>(options: Options<CreateUserRateData, ThrowOnError>): RequestResult<CreateUserRateResponses, CreateUserRateErrors, ThrowOnError> => (options.client ?? client).post<CreateUserRateResponses, CreateUserRateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/user-rates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a UserRate
 */
export const deleteUserRate = <ThrowOnError extends boolean = false>(options: Options<DeleteUserRateData, ThrowOnError>): RequestResult<DeleteUserRateResponses, DeleteUserRateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserRateResponses, DeleteUserRateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/user-rates/{id}',
    ...options
});

/**
 * Get one UserRate
 */
export const getUserRate = <ThrowOnError extends boolean = false>(options: Options<GetUserRateData, ThrowOnError>): RequestResult<GetUserRateResponses, GetUserRateErrors, ThrowOnError> => (options.client ?? client).get<GetUserRateResponses, GetUserRateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/user-rates/{id}',
    ...options
});

/**
 * Update a UserRate
 */
export const updateUserRate = <ThrowOnError extends boolean = false>(options: Options<UpdateUserRateData, ThrowOnError>): RequestResult<UpdateUserRateResponses, UpdateUserRateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserRateResponses, UpdateUserRateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/user-rates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * RevenueCat server-to-server event
 */
export const revenueCatWebhook = <ThrowOnError extends boolean = false>(options: Options<RevenueCatWebhookData, ThrowOnError>): RequestResult<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError> => (options.client ?? client).post<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError>({
    url: '/v1/webhooks/revenuecat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List WorkspaceInvitation rows
 */
export const listWorkspaceInvitations = <ThrowOnError extends boolean = false>(options?: Options<ListWorkspaceInvitationsData, ThrowOnError>): RequestResult<ListWorkspaceInvitationsResponses, ListWorkspaceInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkspaceInvitationsResponses, ListWorkspaceInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-invitations',
    ...options
});

/**
 * Invite someone by email
 */
export const inviteToWorkspace = <ThrowOnError extends boolean = false>(options: Options<InviteToWorkspaceData, ThrowOnError>): RequestResult<InviteToWorkspaceResponses, InviteToWorkspaceErrors, ThrowOnError> => (options.client ?? client).post<InviteToWorkspaceResponses, InviteToWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept or decline an invitation as the invited person
 */
export const respondToWorkspaceInvitation = <ThrowOnError extends boolean = false>(options: Options<RespondToWorkspaceInvitationData, ThrowOnError>): RequestResult<RespondToWorkspaceInvitationResponses, RespondToWorkspaceInvitationErrors, ThrowOnError> => (options.client ?? client).post<RespondToWorkspaceInvitationResponses, RespondToWorkspaceInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-invitations/respond',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get one WorkspaceInvitation
 */
export const getWorkspaceInvitation = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceInvitationData, ThrowOnError>): RequestResult<GetWorkspaceInvitationResponses, GetWorkspaceInvitationErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspaceInvitationResponses, GetWorkspaceInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-invitations/{id}',
    ...options
});

/**
 * Send a fresh invitation link
 */
export const resendWorkspaceInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendWorkspaceInvitationData, ThrowOnError>): RequestResult<ResendWorkspaceInvitationResponses, ResendWorkspaceInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResendWorkspaceInvitationResponses, ResendWorkspaceInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-invitations/{id}/resend',
    ...options
});

/**
 * Withdraw a pending invitation
 */
export const revokeWorkspaceInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeWorkspaceInvitationData, ThrowOnError>): RequestResult<RevokeWorkspaceInvitationResponses, RevokeWorkspaceInvitationErrors, ThrowOnError> => (options.client ?? client).post<RevokeWorkspaceInvitationResponses, RevokeWorkspaceInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-invitations/{id}/revoke',
    ...options
});

/**
 * List WorkspaceMember rows
 */
export const listWorkspaceMembers = <ThrowOnError extends boolean = false>(options?: Options<ListWorkspaceMembersData, ThrowOnError>): RequestResult<ListWorkspaceMembersResponses, ListWorkspaceMembersErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkspaceMembersResponses, ListWorkspaceMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-members',
    ...options
});

/**
 * Delete a WorkspaceMember
 */
export const deleteWorkspaceMember = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkspaceMemberData, ThrowOnError>): RequestResult<DeleteWorkspaceMemberResponses, DeleteWorkspaceMemberErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWorkspaceMemberResponses, DeleteWorkspaceMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-members/{id}',
    ...options
});

/**
 * Get one WorkspaceMember
 */
export const getWorkspaceMember = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceMemberData, ThrowOnError>): RequestResult<GetWorkspaceMemberResponses, GetWorkspaceMemberErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspaceMemberResponses, GetWorkspaceMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-members/{id}',
    ...options
});

/**
 * Update a WorkspaceMember
 */
export const updateWorkspaceMember = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkspaceMemberData, ThrowOnError>): RequestResult<UpdateWorkspaceMemberResponses, UpdateWorkspaceMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWorkspaceMemberResponses, UpdateWorkspaceMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspace-members/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Workspace rows
 */
export const listWorkspaces = <ThrowOnError extends boolean = false>(options?: Options<ListWorkspacesData, ThrowOnError>): RequestResult<ListWorkspacesResponses, ListWorkspacesErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkspacesResponses, ListWorkspacesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces',
    ...options
});

/**
 * Create a Workspace
 */
export const createWorkspace = <ThrowOnError extends boolean = false>(options: Options<CreateWorkspaceData, ThrowOnError>): RequestResult<CreateWorkspaceResponses, CreateWorkspaceErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkspaceResponses, CreateWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a Workspace
 */
export const deleteWorkspace = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkspaceData, ThrowOnError>): RequestResult<DeleteWorkspaceResponses, DeleteWorkspaceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWorkspaceResponses, DeleteWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}',
    ...options
});

/**
 * Get one Workspace
 */
export const getWorkspace = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceData, ThrowOnError>): RequestResult<GetWorkspaceResponses, GetWorkspaceErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspaceResponses, GetWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}',
    ...options
});

/**
 * Update a Workspace
 */
export const updateWorkspace = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkspaceData, ThrowOnError>): RequestResult<UpdateWorkspaceResponses, UpdateWorkspaceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWorkspaceResponses, UpdateWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
